// import { defaultValueTypes } from "framer-motion";

import { tr } from "react-day-picker/locale";
import { Watch } from "react-hook-form";

export const formSections = [
  {
    title: "Generation Type",
    fields: [
      {
        name: "generationType",
        label: "Generation Type",
        type: "select",
        options: [
          { label: 'ID', value:1},
          { label: 'Class', value:2}
        ],
        defaultValue:1,
      },
      {
        name: "generationDivId",
        label: "Div ID",
        type: "text",
        visibleWhen:[
          { 
            field:"generationType", 
            value:1 
          }
        ]
      },
      {
        name: "generationDivClass",
        label: "Div Class",
        type: "text",
        visibleWhen: [
          { 
            field:"generationType", 
            value:2 
          }
        ],
         validation:{
          required: "Class is required"
        }
      },
      {
        name: "generationDivClassIndex",
        label: "Div Class Index",
        type: "text",
        visibleWhen: [
          { 
            field:"generationType", 
            value:2 
          }
        ],
         validation:{
          required: "Class Index is required"
        }
      },
    ],
  },

  {
    title: "Tag Type",
    fields: [
      {
        name: "tagType",
        label: "Tag Type",
        type: "select",
        options: [
          { label: 'ADX', value:'ADX'},
          { label: 'Truereach', value:'Truereach'},
          { label: 'Adsense', value:'Adsense'},
          { label: 'Passback', value:'Passback'},
          { label: 'Third-party', value:'Third Party Tag'},
          { label: 'GAM-direct', value:'GAM Direct'}
        ],
        defaultValue:'ADX',
      },
      {
        name: "headTag",
        label: "Head Tag",
        type: "textarea",
        col: 6,
        validation:(formValues)=>({
          validate:(value)=> {
            if( !value && !formValues.bodyTag) {
              return "Head tag is required"
            }
            return true;
          }
        })
      },
      {
        name: "bodyTag",
        label: "Body Tag",
        type: "textarea",
        col: 6,
        validation:(formValues)=>({
          validate:(value)=> {
            if( !value && !formValues.headTag) {
              return "Body tag is required"
            }
            return true;
          }
        })
        // validation:{
        //   required: "Body tag is required"
        // }
      },
    ]
  }, 

  {
    title: "Ad Setting",
    fields: [   
      {
        name: "wrapperStyle",
        label: "Extra CSS",
        type: "textarea",
        col: 6,
      },
      {
        name: "slot",
        label: "Slot",
        type: "select",
        options: [
          { label: "None", value: "None" },
          // { label: "-1*-1--1x-1", value: "-1*-1" },
          { label: "120*20-120x20", value: "120*20" },
          { label: "168*28-168x28", value: "168*28" },
          { label: "216*36-216x36", value: "216*36" },
          { label: "300*250-300x250", value: "300*250" },
          { label: "300*50-300x50", value: "300*50" },
          { label: "320*50-320x50", value: "320*50" },
          { label: "970*250-970x250", value: "970*250" },
          { label: "300*600-300x600", value: "300*600" },
          { label: "300*1050-300x1050", value: "300*1050" },
          { label: "970*90-970x90", value: "970*90" },
          { label: "180*150-180x150", value: "180*150" },
          { label: "160*600-160x600", value: "160*600" },
          { label: "728*90-728x90", value: "728*90" },
          { label: "120*60-120x60", value: "120*60" },
          { label: "88*31-88x31", value: "88*31" },
          { label: "550*480-550x480", value: "550*480" },
          { label: "0*0-0x0", value: "0*0" },
          { label: "320*480-320x480", value: "320*480" },
          { label: "480*320-480x320", value: "480*320" },
          { label: "120*600-120x600", value: "120*600" },
          { label: "468*60-468x60", value: "468*60" },
          { label: "768*1024-768x1024", value: "768*1024" },
          { label: "1024*768-1024x768", value: "1024*768" },
          { label: "480*80-480x80", value: "480*80" },
          { label: "800*480-800x480", value: "800*480" },
          { label: "480*800-480x800", value: "480*800" },
          { label: "336*280-336x280", value: "336*280" },
          { label: "640*360-640x360", value: "640*360" },
          { label: "1920*1080-1920x1080", value: "1920*1080" },
          { label: "1280*720-1280x720", value: "1280*720" },
          { label: "492*412-492x412", value: "492*412" },
          { label: "640*100-640x100", value: "640*100" },
          { label: "300*100-300x100", value: "300*100" },
          { label: "320*100-320x100", value: "320*100" },
          { label: "300*400-300x400", value: "300*400" },
          { label: "320*240-320x240", value: "320*240" },
          { label: "320*320-320x320", value: "320*320" },
          { label: "200*200-200x200", value: "200*200" },
          { label: "250*250-250x250", value: "250*250" },
          { label: "320*150-320x150", value: "320*150" },
          { label: "800*1280-800x1280", value: "800*1280" },
          { label: "320*568-320x568", value: "320*568" },
          { label: "240*400-240x400", value: "240*400" },
          { label: "250*360-250x360", value: "250*360" },
          { label: "580*400-580x400", value: "580*400" },
          { label: "930*180-930x180", value: "930*180" },
          { label: "980*120-980x120", value: "980*120" },
          { label: "640*960-640x960", value: "640*960" },
          { label: "720*1280-720x1280", value: "720*1280" },
          { label: "1440*2960-1440x2960", value: "1440*2960" },
          { label: "1440*2560-1440x2560", value: "1440*2560" },
          { label: "1080*1920-1080x1920", value: "1080*1920" },
          { label: "1280*800-1280x800", value: "1280*800" },
          { label: "480*854-480x854", value: "480*854" },
          { label: "540*960-540x960", value: "540*960" },
          { label: "1440*2880-1440x2880", value: "1440*2880" },
          { label: "1080*2160-1080x2160", value: "1080*2160" },
          { label: "1920*1200-1920x1200", value: "1920*1200" },
          { label: "1024*600-1024x600", value: "1024*600" },
          { label: "720*1440-720x1440", value: "720*1440" },
          { label: "2048*1536-2048x1536", value: "2048*1536" },
          { label: "1440*3120-1440x3120", value: "1440*3120" },
          { label: "1080*2280-1080x2280", value: "1080*2280" },
          { label: "2560*1600-2560x1600", value: "2560*1600" },
          { label: "720*1480-720x1480", value: "720*1480" },
          { label: "480*960-480x960", value: "480*960" },
          { label: "1080*2340-1080x2350", value: "1080*2340" },
          { label: "1080*2180-1080x2180", value: "1080*2180" },
          { label: "1366*768-1366x768", value: "1366*768" },
          { label: "1080*2220-1080x2220", value: "1080*2220" },
          { label: "1312*2560-1312x2560", value: "1312*2560" },
          { label: "1900*1200-1900x1200", value: "1900*1200" },
          { label: "720*1520-720x1520", value: "720*1520" },
          { label: "1400*2392-1400x2392", value: "1400*2392" },
          { label: "1600*2560-1600x2560", value: "1600*2560" },
          { label: "720*1080-720x1080", value: "720*1080" },
          { label: "1080*2244-1080x2244", value: "1080*2244" },
          { label: "720*960-720x960", value: "720*960" },
          { label: "2160*3840-2160x3840", value: "2160*3840" },
          { label: "1080*1620-1080x1620", value: "1080*1620" },
          { label: "2160*1440-2160x1440", value: "2160*1440" },
          { label: "750*1334-750x1334", value: "750*1334" },
          { label: "1080*2246-1080x2246", value: "1080*2246" },
          { label: "1440*900-1440x900", value: "1440*900" },
          { label: "400*800-400x800", value: "400*800" },
          { label: "2560*1800-2560x1800", value: "2560*1800" },
          { label: "1280*1920-1280x", value: "1280*1920" },
          { label: "480*850-480x850", value: "480*850" },
          { label: "768*1280-768x1280", value: "768*1280" },
          { label: "240*320-240x320", value: "240*320" },
          { label: "845*140-845x140", value: "845*140" },
          { label: "970*66-970x66", value: "970*66" },
          { label: "996*372-996x372", value: "996*372" },
          { label: "1280*400-1280x400", value: "1280*400" },
          { label: "400*300-400x300", value: "400*300" },
          { label: "360*640-360x640", value: "360*640" },
          { label: "360*240-360x240", value: "360*240" },
          { label: "420*70-420x70", value: "420*70" },
          { label: "396*266-396x266", value: "396*266" },
          { label: "382*260-382x260", value: "382*260" },
          { label: "595*595-595x595", value: "595*595" },
          { label: "595*596-595x596", value: "595*596" },
          { label: "970*50-970x50", value: "970*50" },
          { label: "310*260-310x260", value: "310*260" },
          { label: "300*180-300x180", value: "300*180" },
          { label: "300*168-300x168", value: "300*168" },
          { label: "300*250-300x250", value: "300*250" },
          { label: "300*300-300x300", value: "300*300" }
        ],
        defaultValue:'None',
        validation:{
          validate:value => value !== "None" || "Please select the valid slot size",
          // required: "Slot size is required"
        }
      },
      {
        name: "deviceType",
        label: "Device Type",
        type: "select",
        options: [
          { label: 'MOBILE', value:'MOBILE'},
          { label: 'DESKTOP', value:'DESKTOP'},
          { label: 'Both', value:'UNKNOWN'},
        ],
        defaultValue:'MOBILE',
      },
      {
        name: "interscrollerFeature",
        label: "Format Type",
        type: "select",
        options: [
          { label: 'Banner', value:""},
          { label: 'Interscroller', value:"interscroller"},
          { label: 'Sticky', value:"sticky"},
          { label: 'Sticky-scroll', value:"sticky-scroll"},
          { label: 'Interstitial', value:"interstitial"},
          { label: 'AnchorAds', value:"AnchorAds"},
          { label: 'Multiplex-Interstitial', value:"multiplex_int"},
          { label: 'VignetteAds', value:"VignetteAds"},
          { label: 'Rewarded Ad', value:"RewardedAds"},
        ],
        // validation:{
        //   required: "Format Type is required"
        // },
        helperText:"The default format type is 'Banner' when nothing is selected."
      },
      {
        name: "adUnitId",
        label: "Ad Unit Slot ID",
        type: "text",
        helperText: "To manage ad rendering order.",
        visibleWhen:[
          {
            field:"interscrollerFeature",
            value:["VignetteAds", "RewardedAds", "AnchorAds"]
          }
        ],
        validation:{
          required: "Ad Unit Slot ID is required"
        }
      },
      {
        name: "primAdUnfillRetryCounter",
        label: "Primary Ad-unfill Retry Counter(min 0 max 10)",
        type: "number",
        validation: () => ({
          validate: (value)=> {
            if( value === "" || value === undefined || value === null ) {
              return "Primary Ad-unfill Retry Counter is required";
            }
            if(Number(value) < 0) {
              return "Minimum value is 0";
            }
            if (Number(value) > 10) {
            return "Maximum value is 10";
            }
            return true;
          // min: {
          //     value: 0,
          //     message: "Minimum value is 0"
          // },
          // max: {
          //     value: 10,
          //     message: "Maximum value is 10"
          //   },
          }
        }),
          visibleWhen:[
            {
              field:"interscrollerFeature",
              value:"multiplex_int"
            }
          ]
      },
      {
        name: "secAdUnfillRetryCounter",
        label: "Secondary/Multi Ad-unfill Retry Counter(min 0 max 10)",
        type: "number",
        visibleWhen:[
          {
            field:"interscrollerFeature",
            value:"multiplex_int"
          }
        ],
        validation: () => ({
          validate : (value) => {
            if( value === "" || value === undefined || value === null ) {
              return "Primary Ad-unfill Retry Counter is required";
            } 
            if(Number(value) < 0) {
              return "Minimum value is 0";
            }
            if (Number(value) > 10) {
            return "Maximum value is 10";
            }
            return true;
          }
        }),
        //   min: {
        //     value: 0,
        //     message: "Minimum value is 0"
        // },
        // max: {
        //     value: 10,
        //     message: "Maximum value is 10"
        // }
        // }
      },
      {
        name: "mainAdUnitSize",
        label: "Main Ad Unit Sizes",
        type: "text",
        visibleWhen:[
          {
            field:"interscrollerFeature",
            value:"multiplex_int"
          }
        ],
        validation:{
          required:"Main Ad Unit Size is require"
        }
      },
      {
        name: "intlSlot",
        label: "Size Limit for creative",
        type: "select",
        visibleWhen:[
          { 
            field:"interscrollerFeature", 
            value:"interscroller" 
          }
        ],
        options: [
          { label: "None", value: "None" },
          { label: "-1*-1--1x-1", value: "-1*-1" },
          { label: "120*20-120x20", value: "120*20" },
          { label: "168*28-168x28", value: "168*28" },
          { label: "216*36-216x36", value: "216*36" },
          { label: "300*250-300x250", value: "300*250" },
          { label: "300*50-300x50", value: "300*50" },
          { label: "320*50-320x50", value: "320*50" },
          { label: "970*250-970x250", value: "970*250" },
          { label: "300*600-300x600", value: "300*600" },
          { label: "300*1050-300x1050", value: "300*1050" },
          { label: "970*90-970x90", value: "970*90" },
          { label: "180*150-180x150", value: "180*150" },
          { label: "160*600-160x600", value: "160*600" },
          { label: "728*90-728x90", value: "728*90" },
          { label: "120*60-120x60", value: "120*60" },
          { label: "88*31-88x31", value: "88*31" },
          { label: "550*480-550x480", value: "550*480" },
          { label: "0*0-0x0", value: "0*0" },
          { label: "320*480-320x480", value: "320*480" },
          { label: "480*320-480x320", value: "480*320" },
          { label: "120*600-120x600", value: "120*600" },
          { label: "468*60-468x60", value: "468*60" },
          { label: "768*1024-768x1024", value: "768*1024" },
          { label: "1024*768-1024x768", value: "1024*768" },
          { label: "480*80-480x80", value: "480*80" },
          { label: "800*480-800x480", value: "800*480" },
          { label: "480*800-480x800", value: "480*800" },
          { label: "336*280-336x280", value: "336*280" },
          { label: "640*360-640x360", value: "640*360" },
          { label: "1920*1080-1920x1080", value: "1920*1080" },
          { label: "1280*720-1280x720", value: "1280*720" },
          { label: "492*412-492x412", value: "492*412" },
          { label: "640*100-640x100", value: "640*100" },
          { label: "300*100-300x100", value: "300*100" },
          { label: "320*100-320x100", value: "320*100" },
          { label: "300*400-300x400", value: "300*400" },
          { label: "320*240-320x240", value: "320*240" },
          { label: "320*320-320x320", value: "320*320" },
          { label: "200*200-200x200", value: "200*200" },
          { label: "250*250-250x250", value: "250*250" },
          { label: "320*150-320x150", value: "320*150" },
          { label: "800*1280-800x1280", value: "800*1280" },
          { label: "320*568-320x568", value: "320*568" },
          { label: "240*400-240x400", value: "240*400" },
          { label: "250*360-250x360", value: "250*360" },
          { label: "580*400-580x400", value: "580*400" },
          { label: "930*180-930x180", value: "930*180" },
          { label: "980*120-980x120", value: "980*120" },
          { label: "640*960-640x960", value: "640*960" },
          { label: "720*1280-720x1280", value: "720*1280" },
          { label: "1440*2960-1440x2960", value: "1440*2960" },
          { label: "1440*2560-1440x2560", value: "1440*2560" },
          { label: "1080*1920-1080x1920", value: "1080*1920" },
          { label: "1280*800-1280x800", value: "1280*800" },
          { label: "480*854-480x854", value: "480*854" },
          { label: "540*960-540x960", value: "540*960" },
          { label: "1440*2880-1440x2880", value: "1440*2880" },
          { label: "1080*2160-1080x2160", value: "1080*2160" },
          { label: "1920*1200-1920x1200", value: "1920*1200" },
          { label: "1024*600-1024x600", value: "1024*600" },
          { label: "720*1440-720x1440", value: "720*1440" },
          { label: "2048*1536-2048x1536", value: "2048*1536" },
          { label: "1440*3120-1440x3120", value: "1440*3120" },
          { label: "1080*2280-1080x2280", value: "1080*2280" },
          { label: "2560*1600-2560x1600", value: "2560*1600" },
          { label: "720*1480-720x1480", value: "720*1480" },
          { label: "480*960-480x960", value: "480*960" },
          { label: "1080*2340-1080x2350", value: "1080*2340" },
          { label: "1080*2180-1080x2180", value: "1080*2180" },
          { label: "1366*768-1366x768", value: "1366*768" },
          { label: "1080*2220-1080x2220", value: "1080*2220" },
          { label: "1312*2560-1312x2560", value: "1312*2560" },
          { label: "1900*1200-1900x1200", value: "1900*1200" },
          { label: "720*1520-720x1520", value: "720*1520" },
          { label: "1400*2392-1400x2392", value: "1400*2392" },
          { label: "1600*2560-1600x2560", value: "1600*2560" },
          { label: "720*1080-720x1080", value: "720*1080" },
          { label: "1080*2244-1080x2244", value: "1080*2244" },
          { label: "720*960-720x960", value: "720*960" },
          { label: "2160*3840-2160x3840", value: "2160*3840" },
          { label: "1080*1620-1080x1620", value: "1080*1620" },
          { label: "2160*1440-2160x1440", value: "2160*1440" },
          { label: "750*1334-750x1334", value: "750*1334" },
          { label: "1080*2246-1080x2246", value: "1080*2246" },
          { label: "1440*900-1440x900", value: "1440*900" },
          { label: "400*800-400x800", value: "400*800" },
          { label: "2560*1800-2560x1800", value: "2560*1800" },
          { label: "1280*1920-1280x", value: "1280*1920" },
          { label: "480*850-480x850", value: "480*850" },
          { label: "768*1280-768x1280", value: "768*1280" },
          { label: "240*320-240x320", value: "240*320" },
          { label: "845*140-845x140", value: "845*140" },
          { label: "970*66-970x66", value: "970*66" },
          { label: "996*372-996x372", value: "996*372" },
          { label: "1280*400-1280x400", value: "1280*400" },
          { label: "400*300-400x300", value: "400*300" },
          { label: "360*640-360x640", value: "360*640" },
          { label: "360*240-360x240", value: "360*240" },
          { label: "420*70-420x70", value: "420*70" },
          { label: "396*266-396x266", value: "396*266" },
          { label: "382*260-382x260", value: "382*260" },
          { label: "595*595-595x595", value: "595*595" },
          { label: "595*596-595x596", value: "595*596" },
          { label: "970*50-970x50", value: "970*50" },
          { label: "310*260-310x260", value: "310*260" },
          { label: "300*180-300x180", value: "300*180" },
          { label: "300*168-300x168", value: "300*168" },
          { label: "300*250-300x250", value: "300*250" },
          { label: "300*300-300x300", value: "300*300" }
        ],
        helperText:"From Ad Response, greater than size limit, creative work as interscroller rest show as normal Ad.",
        defaultValue:"None",
      },
      {
        name: "position",
        label: "Position",
        type: "select",
        validation:{
          required: "Position is required"
        },
        options: [
          { 
            label: 'Top', 
            value:"top",
          },
          { 
            label: 'Bottom', 
            value:"bottom",
          },
          { label: 'Left', value:"left",
            visibleWhen:[
              { 
                field:"interscrollerFeature", 
                // notIn: "sticky-scroll", 
                value:"sticky"
              }
            ]
          },
          { label: 'Right', value:"right",
            visibleWhen:[
              { 
                field:"interscrollerFeature", 
                value:"sticky"
              }
            ]
          },
        ],
        defaultValue:"top",
        visibleWhen:[
          { 
            field:"interscrollerFeature",
            value:["sticky", "sticky-scroll", "AnchorAds"]
          }
        ],
      },  
      // {
      //   name: "position",
      //   label: "Position",
      //   type: "select",
      //   options: [
      //     { label: 'Top', value:"top"},
      //     { label: 'Bottom', value:"bottom"},
      //   ],
      //   visibleWhen:[
      //     {
      //       field:"desiredFormat",
      //       value:"sticky-scroll"
      //     } 
      //   ]
      // },  
      {
        name: "skipAd",
        label: "Skip Ad",
        type: "select",
        options: [
          { label: 'Yes', value:"1"},
          { label: 'No', value:""},
        ],
        defaultValue:"",
        visibleWhen:[
          {
            field:"interscrollerFeature",
            value:["sticky", "sticky-scroll"]
          }
        ]
      }, 
      // {
      //   name: "adCloseBtn",
      //   label: "Skip Ad Close Button",
      //   type: "select",
      //   options: [
      //     { label: 'Top Skip Text', value:"SKIP"},
      //   ],
      //   visibleWhen:[ 
      //     {
      //       field:"desiredFormat",
      //       value:["sticky", "sticky-scroll"]
      //     }
      //   ]
      // }, 
      {
        name: "adCloseBtn",
        label: "Skip Ad Close Button",
        type: "select",
        options: [
          { label: 'Top Skip Text', value:"SKIP",
            visibleWhen:[
              // {
              //   field:"viaGam",
              //   value:["0", "2"],
              // },
              { 
                field:"interscrollerFeature",
                notIn:["multiplex_int"]
              }
            ],
          },
          { label: 'Top Cross (X)', value:"CROSS",
            visibleWhen:[
              {
                field:"interscrollerFeature",
                notIn:["sticky", "sticky-scroll", "multiplex_int"]
              }
            ]
          },
          { label: 'Right Cross (X)', value:"CLOSE",
            visibleWhen:[
              {
                field:"interscrollerFeature",
                notIn:["sticky", "sticky-scroll", "multiplex_int"]
              },
              // {
              //   field:"viaGam",
              //   value:"1",
              // }
            ]
          },
          { label: 'Left Cross (X)', value:"LFCLOSE",
            visibleWhen:[
              {
                field:"interscrollerFeature",
                notIn:["sticky", "sticky-scroll", "multiplex_int"]
              }
            ]
          },
          { label: 'Right Close Text', value:"RTCLOSE",
            visibleWhen:[
              {
                field:"interscrollerFeature",
                notIn:["sticky", "sticky-scroll", "multiplex_int"]
              },
              // {
              //   field:"viaGam",
              //   notIn:["0", "2"]
              // }
            ]
          },
          { label: 'Left Close Text', value:"LFTCLOSE",
            visibleWhen:[
              {
                field:"interscrollerFeature",
                notIn:["sticky", "sticky-scroll", "multiplex_int"]
              },
              // {
              //   field:"viaGam",
              //   notIn:["0", "2"]
              // }
            ]
          },
          { label: 'Screen Corner Cross (X)', value:"CORNER",
            visibleWhen:[
              {
                field:"interscrollerFeature",
                value:["interstitial", "multiplex_int"]
              },
            ]
          },
          { label: 'Vignette Cross (X)', value:"VCORNER",
            visibleWhen:[
              {
                field:"interscrollerFeature",
                notIn:["sticky", "sticky-scroll"]
              },
              {
                field:"interscrollerFeature",
                notIn:["multiplex_int"]
              }
            ]
          },
        ],
        visibleWhen:[
          {
            field:"interscrollerFeature",
            notIn:["interscroller", "AnchorAds", "VignetteAds", "RewardedAds", ""]
          }
        ],
        defaultValue: "SKIP",
      },  
      // {
      //   name: "skipAd1",
      //   label: "Position",
      //   type: "select",
      //   options: [
      //     { label: 'Top', value:"top"},
      //     { label: 'Bottom', value:"bottom"},
      //   ],
      //   visibleWhen:[
      //     {
      //       field:"desiredFormat",
      //       value:"sticky"
      //     }
      //   ]
      // },  
      {
        name: "viaGam",
        label: "Mapped as GAM creative",
        type: "select",
        options: [
          { label: 'Serve inside GAM Iframe', value:"1"},
          { label: 'Serve outside GAM Iframe', value:"2"},
          { label: 'No', value:"0"},
        ],
        defaultValue:"0",
        // visibleWhen:[
        //   {
        //     field:"interscrollerFeature",
        //     value:["interstitial", ""]
        //   }
        // ],
        // validation:(formValues) => ({
        //   validate:(value)=> {
        //     if((["", "interscroller","sticky","sticky-scroll","AnchorAds","multiplex_int"].includes(formValues.interscrollerFeature)) && value === "2") {
        //         return "This format is not allowed to serve outside GAM Iframe";
        //     }
        //     return true;
        //   }
        // })
      },  
      {
        name: "ampSupport",
        label: "Is AMP Page",
        type: "select",
        options: [
          { label: 'No', value:""},
          { label: 'Yes', value:"1"},
        ],
        defaultValue:"",
        visibleWhen:[
          {
            field:"interscrollerFeature",
            notIn:["VignetteAds", "RewardedAds", "AnchorAds"]
          }
        ]
      },
      {
        name: "isCurrPageUrl",
        label: "Test Page",
        type: "select",
        options: [
          { label: 'No', value:"0"},
          { label: 'Yes', value:"1"},
        ],
        defaultValue:"0",
      },
      // {
      //   name: "adCloseBtn",
      //   label: "Skip Ad Close Button",
      //   type: "select",
      //   options: [
      //     { label: 'Top Skip Text', value:"SKIP"},
      //     { label: 'Top Cross (X)', value:"CROSS"},
      //     { label: 'Right Cross (X)', value:"CLOSE"},
      //     { label: 'Left Cross (X)', value:"LFCLOSE"},
      //     { label: 'Screen Corner Cross (X)', value:"CORNER"},
      //     { label: 'Vignette Cross (X)', value:"VCORNER"},
      //   ]
      // },
      {
        name: "gamCreative",
        label: "GAM Creative ID",
        type: "textarea",
        col: 6,
        helperText: "Place house line-item creative IDs in comma separated to remove interstitial format for instream video.",
        visibleWhen:[
          {
            field:"interscrollerFeature",
            value:["interstitial"]
          }
        ]
      },
      {
        name: "intlReq",
        label: "Block initial page Request",
        type: "select",
        helperText: "In case of refresh Block Initial Request will not work.",
        options: [
          { label: 'No', value:"0"},
          { label: 'Yes', value:"1"},
        ],
        visibleWhen:[
          {
            field:"interscrollerFeature",
            value:["interstitial", "VignetteAds", "RewardedAds"]
          }
        ],
        defaultValue:0,
      },
      {
        name: "blockOwnInt",
        label: "Block Interstitial Ad Request After Serving Vignette",
        type: "select",
        options: [
          { label: 'No', value:""},
          { label: 'Yes', value:"1"},
        ],
        visibleWhen:[
          {
            field:"interscrollerFeature",
            value:["VignetteAds"]
          }
        ],
        defaultValue:"",
      },
      {
        name: "interstitialAction",
        label: "Is Interstitial On Action?",
        type: "select",
        options: [
          { label: 'Request On Load', value:"1"},
          { label: 'Request On Click', value:"2"},
          { label: 'No', value:""},
        ],
        visibleWhen:[
          {
            field:"interscrollerFeature",
            value:"interstitial"
          }
        ],
        helperText: "Interstitial will not support on page load/reload. Works like Vignette Ads.",
        defaultValue:"",
      },
      {
        name: "intlActionPerSession",
        label: "Ad Render Per session",
        type: "select",
        options: [
          { label: 'Same Tab Without Expiration Time', value:"1"},
          { label: 'Same/New Tab With Expiration Time', value:"2"},
          { label: 'No', value:""},
        ],
        visibleWhen:[
          {
          field:"interscrollerFeature",
          value:"interstitial"
          }
        ],
        helperText: "Allow to Ad display Per session.",
        defaultValue:"",
      },
      {
        name: "intlActionSessionCounter",
        label: "Ad Render Per session counter",
        type: "number",
        helperText: "To display ad nth counter per session.",
        visibleWhen:[
          {
            field:"intlActionPerSession",
            value:["1", "2"]
          }
        ],
        validation:{
          required: "Ad Render Per session counter is required"
        }
      },
      {
        name: "intlActionSessionExptime",
        label: "Session expiration time (In Minutes)",
        type: "text",
        helperText: "Expiration time to handle session for new tab.",
        visibleWhen:[
          {
            field:"intlActionPerSession",
            value:"2"
          }
        ]
      },
      {
        name: "status",
        label: "Status",
        type: "select",
        options: [
          { label: 'Pending', value:5},
          { label: 'Active', value:1},
        ],
        defaultValue:1,
      },
      {
        name: "remarks",
        label: "Remarks",
        type: "textarea",
        col: 6,
      },
      {
        name: "timeOut",
        label: "Timeout (In Seconds)",
        type: "number",
        helperText: "To handle main ad rendering.",
        validation:{
          required : "Timeout is required, enter value in second"
        },
        defaultValue:"50"
      },
      {
        name: "priority",
        label: "Order",
        type: "number",
        col: 6,
        helperText: "To manage ad rendering order.",
        validation:{
          min: {
            value: 0,
            message: "Minimum value is 0"
        }
        }
      },
      {
        name: "useAsCallback",
        label: "Use as callback method",
        type: "select",
        options: [
          { label: 'Both (Callback + Initial Load)', value:"1"},
          { label: 'Callback only', value:"2"},
          { label: 'No', value:""},
        ],
        defaultValue:"",
      },
      {
        name: "startDate",
        label: "Start Date",
        type: "datetime-local",
        validation: (formValues) => ({
            validate: (value) => {
              if ((String(formValues.hiddenCreative) === "1" || String(formValues.desiredFormat) !== "") && !value) {
                    return "Start Date is required";
                }
                return true;
            }
        })
      },
      {
        name: "endDate",
        label: "End Date",
        type: "datetime-local",
        validation:(formValues) => ({
          validate: (value) => {
          if((String(formValues.hiddenCreative) === "1" || String(formValues.desiredFormat) !== "") && !value) {
            return "End Date is required";
          }
          return true;
        }
        })
      },
      {
        name: "hiddenCreative",
        label: "Use as Non-displaying creative",
        type: "select",
        options: [
          { label: 'Yes', value:"1"},
          { label: 'No', value:""},
        ],
        defaultValue:"",
        helperText:"In case of yes, only ad request will fired and creative will not be rendered.",
        visibleWhen:[
          {
            field:"interscrollerFeature",
            value:[ "", "interscroller", "sticky", "sticky-scroll", "interstitial" ]
          }
        ]
      },
      {
        name: "desiredFormat",
        label: "Desired Format",
        type: "select",
        options: [
          { label: 'None', value:""},
          { label: 'Interscroller', value:"interscroller"},
          { label: 'Sticky', value:"sticky"},
          { label: 'Interstitial', value:"interstitial"},
        ],
        defaultValue:"",
        visibleWhen : [
          {
            field:"hiddenCreative",
            value : "",
          },
          {
            field:"interscrollerFeature",
            value : [ "", "interscroller", "sticky", "sticky-scroll", "interstitial" ],
          }
        ],
          validation : (formValues)=> ({
            validate : (value)=> {
              if(formValues.interscrollerFeature === value && (value !== "")) {
                return "You cannot select the Desired format and Format type as same."
              }
              return true;
            }
          })
      },
      {
        name: "desRefresh",
        label: "Refresh",
        type: "select",
        options: [
          { label: 'No', value:""},
          { label: 'Yes', value:"1"},
        ],
        visibleWhen:[
          {
            field:"desiredFormat",
            value:"interstitial",
          }
        ],
        defaultValue:"",
      },
      {
        name: "desRefreshTime",
        label: "Desired Refresh Ad Time (In Seconds)",
        type: "text",
        visibleWhen:[
          {
            field:"desRefresh",
            value:"1",
          },
          {
            field:"desiredFormat",
            value:"interstitial",
          }
        ],
        validation:{
          required:"Desired Refresh Ad Time is required"
        }
      },
    ]  
  },

  {
    title: "Page Url Setting",
    fields:[
      {
        name: "pageUrl",
        label: "Inclusion Page URL (each line is 1 page url)",
        type: "textarea",
        col: 6,
      },
      {
        name: "isAllInclusionPageUrl",
        label: "Is Inclusion Page Url Applicable for all AdUnits",
        type: "select",
        options: [
          { label: 'No', value:0},
          { label: 'Yes', value:1},
        ],
        defaultValue:0,
      },
      {
        name: "exclusionPageUrl",
        label: "Exclusion Page URL (each line is 1 page url)",
        type: "textarea",
        col: 6,
        validation:(formValues)=> ({
          validate:(value)=> {
            if( formValues.useFromExclFile === "1" && value !== "" ) {
              return "Exclusion Page URL should be blank in case of exclusion file setting set as Yes."
            }
          }
        })
      },
      // {
      //   name: "exclusionPageUrl",
      //   label: "Exclusion Page URL (each line is 1 page url)",
      //   type: "textarea",
      //   col: 6,
      // },
      {
        name: "useFromExclFile",
        label: "Use from exclusion File",
        type: "select",
        options: [
          { label: 'No', value:"0"},
          { label: 'Yes', value:"1"},
        ],
        defaultValue:"0",
      },
      {
        name: "isAllExclusionPageUrl",
        label: "Is Exclusion Page Url Applicable for all AdUnits",
        type: "select",
        options: [
          { label: 'No', value:0},
          { label: 'Yes', value:1},
        ],
        defaultValue:0,
      },
      {
        name: "extRequestTracker",
        label: "External Tracker URL On AD Request (each line is 1 tracker)",
        type: "textarea",
        col: 6,
      },
      {
        name: "extTrackerUrl",
        label: "External Tracker URL On creative rendering (each line is 1 tracker)",
        type: "textarea",
        col: 6,
      },
    ]
  },

  {
    title: "Powered By Setting",
    fields:[  
    
      {
        name: "poweredByPosition",
        label: "Powered By Position",
        type: "select",
        options: [
          { label: 'Top', value:'top'},
          { label: 'Bottom', value:'bottom'},
        ],
        visibleWhen: [
          {
            field: "interscrollerFeature",
            value: ["", "interstitial", "interscroller", "multiplex_int"]
          }
        ],
        defaultValue:'bottom',
      },
      {
        name: "poweredByType",
        label: "Powered By Click Url",
        type: "text",
      },
      {
        name: "poweredByText",
        label: "Powered By",
        type: "text",
      },
      {
        name: "poweredByImage",
        label: "Powered By Image URL",
        type: "text",
      },
    ],
    visibleWhen: [
      {
        field: "interscrollerFeature",
        notIn: ["RewardedAds", "VignetteAds"]
      }
    ]
  },
  
  {
    title: "ADX Setting",
    fields: [
      {
        name: "eleInView",
        label: "Viewability",
        type: "select",
        options: [
          {label:"Yes", value:"1"},
          {label:"No", value:""},
        ],
        visibleWhen:[
          {
            field:"interscrollerFeature",
            value:["interscroller", ""],
          }
        ],
        defaultValue:"",
        adsenseVisible: true,
      },
      {
        name: "renderMarginView",
        label: "Allow Render Margin Viewability",
        type: "select",
        options: [
          {label:"Yes", value:"1"},
          {label:"No", value:""},
        ],
        visibleWhen:[
          {
            field:"interscrollerFeature",
            value:["interscroller", ""],
          }
        ],
        helperText:"Applicable only on viewability.",
        defaultValue:"",
        adsenseVisible: true,
      },
      {
        name: "inViewPerc",
        label: "In View (%)",
        type: "number",
        helperText: "Applicable only on viewability.",
        visibleWhen:[
          {
            field:"interscrollerFeature",
            value:["interscroller", ""],
          }
        ],
        validation:(formValues) => ({
          validate:(value)=> {
            if( ( String(formValues.eleInView) === "1" || String(formValues.rEleInView) === "1" ) && !value ) {
              return "In View (%) is required";
            }
            if(value < 0) {
              return "In View shoulbe be greater then 0";
            }
            return true;
          }
        }),
        adsenseVisible: true,
      },
      {
        name: "refresh",
        label: "Refresh",
        type: "select",
        options: [
          {label:"Yes", value:"1"},
          {label:"No", value:""},
        ],
        helperText: "Refresh will not work with Interstitial On Action.",
        visibleWhen:[
          {
            field:"interscrollerFeature",
            notIn:["VignetteAds", "RewardedAds", "AnchorAds", "multiplex_int"],
          }
        ],
        validation:(formValues)=> ({
          validate:(value)=> {
            if(formValues.intlReq ==="1" && value === "1" ) {
              return "Refresh should be No when Block initial request is yes."
            }
            return true;
          }
        }),
        defaultValue:"",
      },
      {
        name: "adRotationCounter",
        label: "Ad Rotation Counter On Page",
        type: "text",
        helperText: "To handle ad display only on nth counter when page navigates.",
        visibleWhen:[
          {
            field:"refresh",
            value:"",
          },
          {
            field:"interscrollerFeature",
            notIn:["VignetteAds", "RewardedAds"],
          }         
        ],
        validation:(formValues)=> ({
          validate:(value)=> {
            if(formValues.intlReq === "1" && !value) {
              return "Ad Rotation Counter is required"
            }
            if(value && (Number(value) < 1 || Number(value) > 10)) {
              return "Ad Rotation Counter value should between 1 to 10"
            }
            return true;
          }
        })
      },
      {
        name: "refreshTime",
        label: "Refresh Ad Time (In Seconds)",
        type: "number",
        helperText: "To handle main ad rendering.",
        visibleWhen:[
          {
            field:"refresh",
            value:"1",
          }          
        ],
        validation: {
          required:"Refresh Ad Time is required"
        }
      },
      {
        name: "unfillRefreshTime",
        label: "Un-filled Request Timer (In Seconds)",
        type: "text",
        helperText:"To handle requests in case of un-fill ad.",
        visibleWhen:[
          {
            field:"refresh",
            value:"1",
          }          
        ]
      },
      {
        name: "actionRequired",
        label: "Refresh on page change/reload",
        type: "select",
        options: [
          {label:"Yes", value:"1"},
          {label:"No", value:""},
        ],
        helperText:"In case of Yes, refresh ad unit will be ignored.",
        visibleWhen:[
          {
            field:"interscrollerFeature",
            value:"interstitial",
          },
          {
            field:"refresh",
            value:"1",
          }          
        ]
      },
      {
        name: "rEleInView",
        label: "Viewability with refresh",
        type: "select",
        options: [
          {label:"Yes", value:"1"},
          {label:"No", value:""},
        ],
        visibleWhen:[
          {
            field:"refresh",
            value:"1",
          }, 
          {
            field:"interscrollerFeature",
            value:["interscroller", "multiplex_int", ""]
          }  
        ],
        defaultValue:"",
      },
      {
        name: "gptId",
        label: "Div GPT ID",
        type: "text",
        validation:{
          required:"Please enter div GPT Id."
        }
      },
      {
        name: "mainAdUnit",
        label: "Main Ad Unit",
        type: "text",
        visibleWhen:[
          {
            field:"refresh",
            value:"1",
          }  
        ],
        validation: {
          required:"Main Ad Unit is required"
        }
      },
      {
        name: "refreshAdUnit",
        label: "Refresh Ad Unit",
        type: "text",
        visibleWhen:[
          {
            field:"refresh",
            value:"1",
          }  
        ],
        validation: {
          required:"Refresh Ad Unit is required"
        }
      },
      {
        name: "approvalStatus",
        label: "Approval Status",
        type: "select",
        options: [
          {label:"Active", value:"1"},
          {label:"Pending", value:"0"},
        ],
        defaultValue:"1",
      },
      {
        name: "sizeMappingVariable",
        label: "Size Mapping Variable",
        type: "text",
        helperText:"To handle variable name which used for sizemappping in head tag. ex:responsiveAdSlot1,responsiveAdSlot2",
        visibleWhen:[
          {
            field:"interscrollerFeature",
            notIn:["VignetteAds", "RewardedAds"],
          }
        ]
      },
      {
        name: "enableHeaderBidding",
        label: "Enable Header Bidding",
        type: "select",
        options: [
          {label:"Yes", value:"1"},
          {label:"No", value:""},
        ],
        helperText:"Apply customized tag, whenever changes will be done.",
        defaultValue:"",
      },
      {
        name: "convertedHeadTag",
        label: "Customized Head Tag",
        type: "textarea",
        col: 6,
        row :60,
        validation:{
          required:"Please apply refresh Head Tag."
        },
        visibleWhen:[
          {
            field : "tagType",
            value : "ADX"
          },
        ]
      },
      {
        name: "convertedBodyTag",
        label: "Customized Body Tag",
        type: "textarea",
        col: 6,
        validation:{
          required:"Please apply refresh Body Tag."
        },
        visibleWhen:[
          {
            field : "tagType",
            value : "ADX"
          },
        ]
      },
      {
        type: "button",
        label: "Apply Customized Tag",
        variant: "primary",
        action: "applyCustomTag",
      },
    ],
    visibleWhen: [
      {
        field : "tagType",
        value : ["ADX", "Adsense"]
      },
    ]
  },

  {
    title: "Waterfall Settings",
    isArray: true,
    name: "mediationDetails",
    fields: [
      {
        name:"wTagType",
        label:"Type",
        type:"select",
        options: [
          {label:"ADX", value:"ADX"},
          {label:"Truereach", value:"Truereach"},
          {label:"Adsense", value:"Adsense"},
          {label:"Passback", value:"Passback"},
          {label:"Third-party", value:"Third Party Tag"},
          {label:"GAM-direct", value:"GAM Direct"},
        ],
        defaultValue:'ADX',
      },
      {
        name: "timeDelay",
        label: "Time Delay",
        type: "text",
      },
      {
        name:"wheadTag",
        label:"Head Tag",
        type:"textarea",
        col: 6,
      },
      {
        name:"wbodyTag",
        label:"Body Tag",
        type:"textarea",
        col: 6,
      },
    ],
  },

  {
    title: "Multi Tag Settings",
    fields: [
      {
        name:"mHeadTag",
        label:"Head Tag",
        type:"textarea",
        col: 6,
      },
      {
        name:"mBodyTag",
        label:"Body Tag",
        type:"textarea",
        col: 6,
      },
      {
        name:"mDivgptID",
        label:"Div GPT ID",
        type:"text",
      },
      {
        name:"mAdUnitSlotId",
        label:"Ad Unit Slot ID",
        type:"text",
        visibleWhen:[
          {
            field:"interscrollerFeature",
            value:["VignetteAds", "RewardedAds", "AnchorAds"]
          }
        ]
      },
      {
        name:"mSizeMappingVariable",
        label:"Size Mapping Variable",
        type:"text",
        visibleWhen:[
          {
            field:"interscrollerFeature",
            notIn:["VignetteAds", "RewardedAds"],
          }
        ]
      },
      {
        name:"mMainAdUnitSize",
        label:"Main Ad Unit",
        type:"text",
        visibleWhen:[
          {
            field:"refresh",
            value:"1",
          }
        ],
        validation: (formValues, index) => ({
          validate : (value) => {
            const row = formValues.multitagSetting?.[index];
            if( (row?.mHeadTag || row?.mBodyTag) && !value ) {
              return "Main Ad Unit is required";
            }
            return true;
          }
        })
      },
      {
        name:"mRefreshAdUnit",
        label:"Refresh Ad Unit",
        type:"text",
        visibleWhen:[
          {
            field:"refresh",
            value:"1",
          }          
        ],
        validation: (formValues, index) => ({
          validate : (value) => {
            const row = formValues.multitagSetting?.[index];
            if ((row?.mHeadTag || row?.mBodyTag) && !value) {
              return "Refresh Ad Unit is required";
            }
            return true;
          }
        })
      },
      {
        name:"mConvertedHeadTag",
        label:"Customized Head Tag",
        type:"textarea",
        col: 6,
      },
      {
        name:"mConvertedBodyTag",
        label:"Customized Body Tag",
        type:"textarea",
        col: 6,
      },
      {
        type: "button",
        label: "Customized Tag",
        variant: "warning",
        action: "applyCustomTagMulti",
      },
    ],
    visibleWhen: [
      {
        field : "tagType",
        value : "ADX",
      },
    ]
  }
];